// extracted by mini-css-extract-plugin
export default {"menuButton":"AppBarHeader_menuButton__PAXf-","flex":"AppBarHeader_flex__RWRks"};